import {t} from "i18next";
import {InputWithIconInformation} from "@/shared/components/atoms/InputWithIconInformation";
import InputRadioGroup from "@/shared/components/molecules/InputRadioGroup";
import {InputWithCornerHint} from "@/shared/components/atoms/InputWithCornerHint";
import {CheckBoxDays} from "@/shared/components/atoms/CheckBoxDays";
import DateRangePickerIconInformation from "@/shared/components/atoms/DateRangePickerIconInformation";
import {DialogCreate} from "@/shared/components/molecules/DialogCreate";
import {
    genderOptions,
    sendingOptions,
    dayOptions,
    eventTypeOptions,
    frequencyOptions,
    triggerTypeOptions,
    dayExpiredOptions,
    daySessionsOptions
} from "@/pages/InternalChats/constants/options";
import {FC, useMemo} from "react";
import { ShippingRulesProps } from "@/pages/InternalChats/interfaces/ShippingRulesProps";
import {toYMD} from "@/pages/InternalChats/utils/handlePublish";
import {MultiSelect} from "@/shared/components/organisms/MultiSelect";
import {toasts} from "@/shared/utils/toasts";

export const ShippingRules: FC<ShippingRulesProps> = ({ formik, openDialog, setOpen, data }) => {

    const groupOptions = useMemo(() => data?.assisteds?.map(g => ({
        id: g.id,
        name: g.name
    })) ?? [], [data]);

    const specialistOptions = useMemo(() => data?.assistedSpecialists?.map(s => ({
        id: s.id,
        name: s.name
    })) ?? [], [data]);

    const trainingPlanOptions = useMemo(() => data?.trainingPlan?.map(t => ({
        id: t.id,
        name: t.name
    })) ?? [], [data]);

    const nutritionPlanOptions = useMemo(() => data?.nutritionPlan?.map(n => ({
        id: n.id,
        name: n.name
    })) ?? [], [data]);

    const categoryOptions = useMemo(() => data?.categories?.map(c => ({
        id: c.id,
        name: c.name
    })) ?? [], [data]);

    const bondsOpts = useMemo(() => data?.bonds?.map(s => ({
        id: s.id,
        name: s.name,
    })) ?? [], [data]);

    const slotsBondsOpts = useMemo(() => data?.slotsBonds?.map(s => ({
        id: s.id,
        name: s.name,
    })) ?? [], [data]);


    const feesOpts = useMemo(() => data?.fees?.map(f => ({
        id: f.id,
        name: f.name,
    })) ?? [], [data?.fees]);

    const handleChangeTriggerOption = (val, triggerOption) => {

        if (val === 8 && triggerOption === 0) {
            toasts.danger(
                "Error",
                "Seleccionar este tipo configurará el envío recurrente de mensajes cada 5 minutos."
            );
            formik.setFieldValue("send_option", 1);
            return;
        }

        formik.setFieldValue("send_option", triggerOption);
    }

    return (
        <DialogCreate
            open={openDialog}
            OnclickCancel={() => setOpen(false)}
            setOpen={setOpen}
            tittle={t("posts-master.views.post_shipping_rules")}
            hideFooter={true}
        >
            <div className="mt-6 mx-2">
                <div className="space-y-12">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b">
                        <div className="flex items-center justify-center h-full text-center">
                            <div>
                                <h2 className="text-base font-semibold leading-7 text-gray-900">
                                    {t("posts-master.views.caracteristics")}
                                </h2>
                                <p className="mt-1 text-sm leading-6 text-gray-600">
                                    {t("posts-master.views.caracteristics_description")}
                                </p>
                            </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                            <div className="col-span-full">
                                {/*<MultiSelectIconInformation*/}
                                {/*    title={t("posts-master.views.sex")}*/}
                                {/*    selectedOptions={formik.values.gender}*/}
                                {/*    setSelectedOptions={(val) => formik.setFieldValue("gender", val)}*/}
                                {/*    options={genderOptions}*/}
                                {/*    textInformation={t("posts-master.views.sex_hint")}*/}
                                {/*/>*/}
                                <MultiSelect
                                    title={t("posts-master.views.sex")}
                                    textInformation={t("posts-master.views.sex_hint")}
                                    selectedOptions={formik.values.gender}
                                    setSelectedOptions={(val) => formik.setFieldValue("gender", val)}
                                    options={genderOptions}
                                />
                            </div>
                            <div className="col-span-full grid grid-cols-[1fr_auto_1fr] items-center gap-6">
                                <InputWithIconInformation
                                    name="min_age"
                                    label={t("posts-master.views.age")}
                                    type="number"
                                    textInformation={t("posts-master.views.age_hint_min")}
                                    value={formik.values.min_age ?? ""}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />

                                {/* Div con la "A" centrada */}
                                <div className="text-center text-gray-900 font-semibold">
                                    {t("posts-master.views.age_between")}
                                </div>

                                <div className="flex flex-col">
                                    <InputWithIconInformation
                                        name="max_age"
                                        label={t("posts-master.views.age")}
                                        type="number"
                                        textInformation={t("posts-master.views.age_hint_max")}
                                        value={formik.values.max_age ?? ""}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                <div className="col-span-full">
                                    {/*<MultiSelectIconInformation*/}
                                    {/*    title={t("posts-master.views.training_plan")}*/}
                                    {/*    selectedOptions={formik.values.training_plan}*/}
                                    {/*    setSelectedOptions={(val) => formik.setFieldValue("training_plan", val)}*/}
                                    {/*    options={trainingPlanOptions}*/}
                                    {/*    textInformation={t("posts-master.views.training_plan_hint")}*/}
                                    {/*/>*/}
                                    <MultiSelect
                                        title={t("posts-master.views.training_plan")}
                                        textInformation={t("posts-master.views.training_plan_hint")}
                                        selectedOptions={formik.values.training_plan}
                                        setSelectedOptions={(val) => formik.setFieldValue("training_plan", val)}
                                        options={trainingPlanOptions}
                                    />
                                </div>
                                <div className="col-span-full">
                                    {/*<MultiSelectIconInformation*/}
                                    {/*    title={t("posts-master.views.nutrition_plan")}*/}
                                    {/*    selectedOptions={formik.values.nutrition_plan}*/}
                                    {/*    setSelectedOptions={(val) => formik.setFieldValue("nutrition_plan", val)}*/}
                                    {/*    options={nutritionPlanOptions}*/}
                                    {/*    textInformation={t("posts-master.views.nutrition_plan_hint")}*/}
                                    {/*/>*/}
                                    <MultiSelect
                                        title={t("posts-master.views.nutrition_plan")}
                                        textInformation={t("posts-master.views.nutrition_plan_hint")}
                                        selectedOptions={formik.values.nutrition_plan}
                                        setSelectedOptions={(val) => formik.setFieldValue("nutrition_plan", val)}
                                        options={nutritionPlanOptions}
                                    />
                                </div>
                                <div className="col-span-full">
                                    <InputRadioGroup
                                        id="send1"
                                        name="send"
                                        text={t("posts-master.views.send_once")}
                                        onChange={() => formik.setFieldValue("send_option", 1)}
                                        checked={formik.values.send_option === 1}
                                    />
                                </div>
                                <div className="col-span-full">
                                    <InputRadioGroup
                                        id="send2"
                                        name="send"
                                        text={t("posts-master.views.send_every")}
                                        onChange={() => {
                                            handleChangeTriggerOption(formik.values.event_type?.id, 0)
                                        }}
                                        checked={formik.values.send_option === 0}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b">
                        <div className="flex items-center justify-center h-full text-center">
                            <div>
                                <h2 className="text-base font-semibold leading-7 text-gray-900">
                                    {t("posts-master.views.trigger")}
                                </h2>
                                <p className="mt-1 text-sm leading-6 text-gray-600">
                                    {t("posts-master.views.trigger_alt")}
                                </p>
                            </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                            <div className="col-span-full">
                                {/*<SelectIconInformation*/}
                                {/*    selected={formik.values.trigger_type}*/}
                                {/*    setSelected={(val) => formik.setFieldValue("trigger_type", val)}*/}
                                {/*    options={triggerTypeOptions}*/}
                                {/*    tittle={t("posts-master.views.trigger")}*/}
                                {/*    textInformation={t("posts-master.views.trigger_hint")}*/}
                                {/*/>*/}
                                <MultiSelect
                                    title={t("posts-master.views.trigger")}
                                    textInformation={t("posts-master.views.trigger_hint")}
                                    selectedOptions={formik.values.trigger_type}
                                    setSelectedOptions={(val) => formik.setFieldValue("trigger_type", val)}
                                    options={triggerTypeOptions}
                                    multiple={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                        <div className="flex items-center justify-center h-full text-center">
                            <div>
                                <h2 className="text-base font-semibold leading-7 text-gray-900">
                                    {t("posts-master.views.event_rules")}
                                </h2>
                                <p className="mt-1 text-sm leading-6 text-gray-600">
                                    {formik.values.trigger_type.id === 1
                                        ? t("posts-master.views.event_rules_alt")
                                        : t("posts-master.views.trigger_alt")}
                                </p>
                            </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                            {formik.values.trigger_type?.id === 1 ? (
                                <>
                                    <div className="col-span-full">
                                        <MultiSelect
                                            title={t("posts-master.views.event_type")}
                                            textInformation={t("posts-master.views.event_type_hint")}
                                            selectedOptions={formik.values.event_type}
                                            setSelectedOptions={(val:any) => {
                                                handleChangeTriggerOption(val.id, formik.values.send_option)
                                                formik.setFieldValue("event_type", val)
                                            }}
                                            options={eventTypeOptions}
                                            multiple={false}
                                        />
                                    </div>
                                    {formik.values.event_type.id === 2 && (
                                        <>
                                            <div className="col-span-full">
                                                {/*<MultiSelectIconInformation*/}
                                                {/*    title={t("posts-master.views.groups")}*/}
                                                {/*    selectedOptions={formik.values.groups}*/}
                                                {/*    setSelectedOptions={(val) => formik.setFieldValue("groups", val)}*/}
                                                {/*    options={groupOptions}* aca esta tod/}
                                                {/*    textInformation={t("posts-master.views.groups_hint")}*/}
                                                {/*/>*/}
                                                <MultiSelect
                                                    title={t("posts-master.views.groups")}
                                                    textInformation={t("posts-master.views.groups_hint")}
                                                    selectedOptions={formik.values.groups}
                                                    setSelectedOptions={(val) => formik.setFieldValue("groups", val)}
                                                    options={groupOptions}
                                                />
                                            </div>
                                            <div className="col-span-full">
                                                {/*<MultiSelectIconInformation*/}
                                                {/*    title={t("posts-master.views.specialist")}*/}
                                                {/*    selectedOptions={formik.values.specialists}*/}
                                                {/*    setSelectedOptions={(val) => formik.setFieldValue("specialists", val)}*/}
                                                {/*    options={specialistOptions}*/}
                                                {/*    textInformation={t("posts-master.views.specialist_hint")}*/}
                                                {/*/>*/}
                                                <MultiSelect
                                                    title={t("posts-master.views.specialist")}
                                                    textInformation={t("posts-master.views.specialist_hint")}
                                                    selectedOptions={formik.values.specialists}
                                                    setSelectedOptions={(val) => formik.setFieldValue("specialists", val)}
                                                    options={specialistOptions}
                                                />
                                            </div>
                                            <div className="col-span-full">
                                                {/*<MultiSelectIconInformation*/}
                                                {/*    title={t("posts-master.views.categories")}*/}
                                                {/*    selectedOptions={formik.values.categories}*/}
                                                {/*    setSelectedOptions={(val) => formik.setFieldValue("categories", val)}*/}
                                                {/*    options={categoryOptions}*/}
                                                {/*    textInformation={t("posts-master.views.categories_hint")}*/}
                                                {/*/>*/}
                                                <MultiSelect
                                                    title={t("posts-master.views.categories")}
                                                    textInformation={t("posts-master.views.categories_hint")}
                                                    selectedOptions={formik.values.categories}
                                                    setSelectedOptions={(val) => formik.setFieldValue("categories", val)}
                                                    options={feesOpts}
                                                />
                                            </div>
                                            <div className="col-span-full">
                                                {/*<SelectIconInformation*/}
                                                {/*    selected={formik.values.sending}*/}
                                                {/*    setSelected={(val) => formik.setFieldValue("sending", val)}*/}
                                                {/*    options={sendingOptions}*/}
                                                {/*    tittle={t("posts-master.views.sending")}*/}
                                                {/*    textInformation={t("posts-master.views.sending_hint")}*/}
                                                {/*/>*/}
                                                <MultiSelect
                                                    title={t("posts-master.views.sending")}
                                                    textInformation={t("posts-master.views.sending_hint")}
                                                    selectedOptions={formik.values.sending}
                                                    setSelectedOptions={(val) => formik.setFieldValue("sending", val)}
                                                    options={sendingOptions}
                                                    multiple={false}
                                                />
                                            </div>
                                        </>
                                    )}
                                    {formik.values.event_type.id === 3 && (
                                        <>
                                            <div className="col-span-full">
                                                {/*<MultiSelectIconInformation*/}
                                                {/*    title={t("posts-master.views.groups")}*/}
                                                {/*    selectedOptions={formik.values.groups}*/}
                                                {/*    setSelectedOptions={(val) => formik.setFieldValue("groups", val)}*/}
                                                {/*    options={groupOptions}*/}
                                                {/*    textInformation={t("posts-master.views.groups_hint")}*/}
                                                {/*/>*/}
                                                <MultiSelect
                                                    title={t("posts-master.views.groups")}
                                                    textInformation={t("posts-master.views.groups_hint")}
                                                    selectedOptions={formik.values.groups}
                                                    setSelectedOptions={(val) => formik.setFieldValue("groups", val)}
                                                    options={groupOptions}
                                                />
                                            </div>
                                            <div className="col-span-full">
                                                {/*<MultiSelectIconInformation*/}
                                                {/*    title={t("posts-master.views.specialist")}*/}
                                                {/*    selectedOptions={formik.values.specialists}*/}
                                                {/*    setSelectedOptions={(val) => formik.setFieldValue("specialists", val)}*/}
                                                {/*    options={specialistOptions}*/}
                                                {/*    textInformation={t("posts-master.views.specialist_hint")}*/}
                                                {/*/>*/}
                                                <MultiSelect
                                                    title={t("posts-master.views.specialist")}
                                                    textInformation={t("posts-master.views.specialist_hint")}
                                                    selectedOptions={formik.values.specialists}
                                                    setSelectedOptions={(val) => formik.setFieldValue("groups", val)}
                                                    options={specialistOptions}
                                                />
                                            </div>
                                            <div className="col-span-full">
                                                {/*<MultiSelectIconInformation*/}
                                                {/*    title={t("posts-master.views.categories")}*/}
                                                {/*    selectedOptions={formik.values.categories}*/}
                                                {/*    setSelectedOptions={(val) => formik.setFieldValue("categories", val)}*/}
                                                {/*    options={categoryOptions}*/}
                                                {/*    textInformation={t("posts-master.views.categories_hint")}*/}
                                                {/*/>*/}
                                                <MultiSelect
                                                    title={t("posts-master.views.categories")}
                                                    textInformation={t("posts-master.views.categories_hint")}
                                                    selectedOptions={formik.values.categories}
                                                    setSelectedOptions={(val) => formik.setFieldValue("categories", val)}
                                                    options={feesOpts}
                                                />
                                            </div>
                                            <div className="col-span-full">
                                                {/*<SelectIconInformation*/}
                                                {/*    selected={formik.values.sending}*/}
                                                {/*    setSelected={(val) => formik.setFieldValue("sending", val)}*/}
                                                {/*    options={sendingOptions}*/}
                                                {/*    tittle={t("posts-master.views.sending")}*/}
                                                {/*    textInformation={t("posts-master.views.sending_hint")}*/}
                                                {/*/>*/}
                                                <MultiSelect
                                                    title={t("posts-master.views.sending")}
                                                    textInformation={t("posts-master.views.sending_hint")}
                                                    selectedOptions={formik.values.sending}
                                                    setSelectedOptions={(val) => formik.setFieldValue("sending", val)}
                                                    options={sendingOptions}
                                                    multiple={false}
                                                />
                                            </div>
                                        </>
                                    )}
                                    {formik.values.event_type.id === 4 && (
                                        <div className="col-span-full">
                                            <InputWithCornerHint
                                                label={t(
                                                    "posts-master.views.event_types.number_days"
                                                )}
                                                type="number"
                                                value={formik.values.nro_day_assistance ?? ""}
                                                onChange={(e) =>
                                                    formik.setFieldValue("nro_day_assistance", +e.target.value)
                                                }
                                            />
                                        </div>
                                    )}
                                    {(formik.values.event_type.id === 5 || formik.values.event_type.id === 6) && (
                                        <div className="col-span-full">
                                            {/*<SelectIconInformation*/}
                                            {/*    selected={formik.values.nro_days_payment}*/}
                                            {/*    setSelected={(val) => formik.setFieldValue("nro_days_payment", val)}*/}
                                            {/*    options={dayOptions}*/}
                                            {/*    tittle={t("posts-master.views.event_types.number_days")}*/}
                                            {/*    textInformation={t("posts-master.views.number_days_hint")}*/}
                                            {/*/>*/}
                                            <MultiSelect
                                                title={t("posts-master.views.event_types.number_days")}
                                                textInformation={
                                                    formik.values.event_type.id === 5
                                                        ? t("posts-master.views.number_days_hint_before")
                                                        : formik.values.event_type.id === 6
                                                            ? t("posts-master.views.number_days_hint_after")
                                                            : t("posts-master.views.number_days_hint_before")
                                                }
                                                selectedOptions={formik.values.nro_days_payment}
                                                setSelectedOptions={(val) => formik.setFieldValue("nro_days_payment", val)}
                                                options={
                                                    formik.values.event_type.id === 5
                                                        ? dayOptions
                                                        : formik.values.event_type.id === 6
                                                            ? dayExpiredOptions
                                                            : dayOptions
                                                }
                                                multiple={false}
                                            />
                                        </div>
                                    )}

                                    {formik.values.event_type.id === 7 && (
                                        <div className="col-span-full">
                                            {/*<SelectIconInformation*/}
                                            {/*    selected={formik.values.number_days}*/}
                                            {/*    setSelected={(val) => formik.setFieldValue("number_days", val)}*/}
                                            {/*    options={dayExpiredOptions}*/}
                                            {/*    tittle={t("posts-master.views.event_types.number_days")}*/}
                                            {/*    textInformation={t("posts-master.views.number_days_hint")}*/}
                                            {/*/>*/}
                                            <MultiSelect
                                                title={t("posts-master.views.event_types.number_days")}
                                                textInformation={t("posts-master.views.number_days_expired_hint")}
                                                selectedOptions={formik.values.number_days}
                                                setSelectedOptions={(val) => formik.setFieldValue("number_days", val)}
                                                options={dayExpiredOptions}
                                                multiple={false}
                                            />
                                        </div>
                                    )}

                                    {formik.values.event_type.id === 9 && (
                                        <div className="col-span-full">
                                            <MultiSelect
                                                title={t("posts-master.views.event_types.number_days")}
                                                textInformation={t("posts-master.views.days_without_connection_hint")}
                                                selectedOptions={formik.values.number_days}
                                                setSelectedOptions={(val) => formik.setFieldValue("number_days", val)}
                                                options={dayExpiredOptions}
                                                multiple={false}
                                            />
                                        </div>
                                    )}

                                    {formik.values.event_type.id === 8 && (
                                        <>
                                            <div className="col-span-full">
                                                {/*<SelectIconInformation*/}
                                                {/*    selected={formik.values.number_days}*/}
                                                {/*    setSelected={(val) => formik.setFieldValue("number_days", val)}*/}
                                                {/*    options={daySessionsOptions}*/}
                                                {/*    tittle={t("posts-master.views.event_types.remaining_sessions")}*/}
                                                {/*    textInformation={t("posts-master.views.number_days_hint")}*/}
                                                {/*/>*/}
                                                <MultiSelect
                                                    title={t("posts-master.views.event_types.remaining_sessions")}
                                                    textInformation={t("posts-master.views.number_days_remaining_sessions_hint")}
                                                    selectedOptions={formik.values.number_days}
                                                    setSelectedOptions={(val) => formik.setFieldValue("number_days", val)}
                                                    options={daySessionsOptions}
                                                    multiple={false}
                                                />
                                            </div>
                                            <div className="col-span-full">
                                                <MultiSelect
                                                    title={t("posts-master.views.bonds")}
                                                    selectedOptions={formik.values.bonds}
                                                    setSelectedOptions={(val) => formik.setFieldValue("bonds", val)}
                                                    options={bondsOpts}
                                                />
                                            </div>
                                            <div className="col-span-full">
                                                <MultiSelect
                                                    title={t("posts-master.views.slotsBonds")}
                                                    selectedOptions={formik.values.slotsBonds}
                                                    setSelectedOptions={(val) => formik.setFieldValue("slotsBonds", val)}
                                                    options={slotsBondsOpts}
                                                />
                                            </div>
                                        </>
                                    )}
                                </>
                            ) : (
                                <>
                                    <div className="col-span-full">
                                        {/*<SelectIconInformation*/}
                                        {/*    selected={formik.values.frequency}*/}
                                        {/*    setSelected={(val) => formik.setFieldValue("frequency", val)}*/}
                                        {/*    options={frequencyOptions}*/}
                                        {/*    tittle={t("posts-master.views.frequency")}*/}
                                        {/*    textInformation={t("posts-master.views.frequency_hint")}*/}
                                        {/*/>*/}
                                        <MultiSelect
                                            title={t("posts-master.views.frequency")}
                                            textInformation={t("posts-master.views.frequency_hint")}
                                            selectedOptions={formik.values.frequency}
                                            setSelectedOptions={(val) => formik.setFieldValue("frequency", val)}
                                            options={frequencyOptions}
                                            multiple={false}
                                        />
                                    </div>
                                    {formik.values.frequency.id === 1 ? (
                                        <>
                                            <div className="col-span-full">
                                                <InputWithIconInformation
                                                    name="date_start"
                                                    label={t("posts-master.views.date")}
                                                    type="date"
                                                    textInformation={t(
                                                        "posts-master.views.date_hint"
                                                    )}
                                                    value={formik.values.date_start ?? ""}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </div>
                                            <div className="col-span-full">
                                                <InputWithIconInformation
                                                    name="hour"
                                                    label={t("posts-master.views.hour")}
                                                    type="time"
                                                    textInformation={t(
                                                        "posts-master.views.hour_hint"
                                                    )}
                                                    value={formik.values.hour ?? ""}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </div>
                                        </>
                                    ) : formik.values.frequency.id === 2 ? (
                                        <>
                                            <div className="col-span-full">
                                                <CheckBoxDays
                                                    value={formik.values.selected_days}
                                                    onChange={(val) => formik.setFieldValue("selected_days", val)}
                                                />
                                            </div>
                                            <div className="col-span-full">
                                                <DateRangePickerIconInformation
                                                    label={t("posts-master.views.interval_date")}
                                                    id="intervaloFechas"
                                                    textInformation={t(
                                                        "posts-master.views.interval_date_hint"
                                                    )}
                                                    onDateChange={(start: Date, end: Date) => {
                                                        formik.setFieldValue("date_start", toYMD(start));
                                                        formik.setFieldValue("date_end",   toYMD(end));
                                                    }}
                                                />
                                            </div>

                                            <div className="col-span-full">
                                                <InputWithIconInformation
                                                    label={t("posts-master.views.hour")}
                                                    type="time"
                                                    textInformation={t(
                                                        "posts-master.views.hour_hint"
                                                    )}
                                                    value={formik.values.hour ?? ""}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </div>
                                        </>
                                    ) : formik.values.frequency.id === 3 ? (
                                        <>
                                            <div className="col-span-full">
                                                <InputWithIconInformation
                                                    name="date_start"
                                                    label={t("posts-master.views.init")}
                                                    type="date"
                                                    textInformation={t(
                                                        "posts-master.views.init_hint"
                                                    )}
                                                    value={formik.values.date_start ?? ""}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </div>
                                            <div className="col-span-full">
                                                <InputWithIconInformation
                                                    name="hour"
                                                    label={t("posts-master.views.hour")}
                                                    type="time"
                                                    textInformation={t(
                                                        "posts-master.views.hour_hint"
                                                    )}
                                                    value={formik.values.hour ?? ""}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </div>
                                            <div className="col-span-full">
                                                <InputWithIconInformation
                                                    name="nro_days_payment"
                                                    label={t("posts-master.views.ends_after")}
                                                    type="number"
                                                    textInformation={t(
                                                        "posts-master.views.ends_after_hint"
                                                    )}
                                                    value={formik.values.nro_days_payment ?? ""}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </DialogCreate>
    )
}